import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocationModel } from './Models/location.model';
import { CategoryModel } from './Models/category.model';
import { AuthService } from '../auth/auth.service';
import { DatePipe } from '@angular/common';
import { UserTypeList } from './Models/usertypelist.model';
import { TimeslotModel } from './Models/timeslot.model';
import { NamePatternModel } from './Models/namepattern.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { OpdVisitService } from '../opdvisits/Services/OpdVisit.service';
import { DilationWithModel } from './Models/dilationwith.model';
import { RemarkModel } from './Models/remark.model';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { OtherInfoddModel } from 'app/table-list/Models/otherinfor_dd.model';
import { docterEmrModel } from './Models/dashboard.model';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})


export class DashboardService {
  public ShowCateName: any;
  public selecteduser: any;
  public  ShowClinicAreaName: any;
  public branchmansterObj: any = {};
  public dashboardMenupermission: any = [];
  helplist: DilationWithModel[] = [];
  total_appointment_count: number;
  pending_appointment_count: number;
  booked_appointment_count: number;
  canceled_appointment_count: number;
  //14
  GetVIP: OtherInfoddModel[] = [];
  //6
  MaritalStatus: OtherInfoddModel[] = [];
  //9
  public ispd:boolean=false;
  GetNationality: OtherInfoddModel[] = [];
  
 // public DashboardColoms: any
  categoryupdated;
  remarkupdated;
  waitingreason;
  public loaderComp: any;
  selectedeye: string;
  dilationwith: string;
  currenttime = this.datePipe.transform(new Date(), "hh:mm:ss");
  finishtime = this.datePipe.transform(new Date(), "hh:mm:ss");
  showspinner = false;
  selectedlocationid: number;
  popup_cancel: boolean = true;
  moudletype =  new Subject<number>();
  todaysdate = this.authservice.localDate;
  public subscriptions:Subscription;
  //todaysdate = "12/04/2018"

  selecteddate = this.datePipe.transform(this.authservice.getServerDate, "yyyy-MM-dd");
  //selecteddate = this.datePipe.transform(this.todaysdate,"dd-MM-yyyy")

  //these properties will be used for move to popup
  pid: number;
  public patientname: string;
  visitid: number;
  pname: string;
  locationid: number;
  prelocationid: number;
  usertypestring: string;
  // public baseUrl:string;
  public newbaseUrl: string;
  //these properties will be used for move to popup
  selectedPatient: any;
  initial: string;
  namepattern: NamePatternModel[] = [];
  timeslots: TimeslotModel[] = [];
  captions: any[] = [];
  widthandcaption: any[] = [];
  columnsToDisplay: string[] = [];
  locations: LocationModel[] = [];
  categories: CategoryModel[] = [];
  usertype_list: UserTypeList[] = [];
  addremark: RemarkModel = {};
  allremarks: RemarkModel[] = [];
  public preloaddahsboard: any = [];

  SequenceCell_Width = "0%";
  ReviewCell_Width = "0%";
  MoveToCell_Width = "0%";
  UHIDCell_Width = "0%";
  PatientNameCell_Width = "0%";
  AgeSexCell_Width = "0%";
  oldmrno_Width = "0%";
  ApptTimeCell_Width = "0%";
  RptTimeCell_Width = "0%";
  CategoryNameCell_Width = "0%";
  ARCell_Width = "0%";
  OPCell_Width = "0%";
  DRCell_Width = "0%";
  PHYCell_Width = "0%";
  PROCell_Width = "0%";
  CDCell_Width = "0%";
  DilationTimeCell_Width = "0%";
  DOCCell_Width = "0%";
  TotalTimeCell_Width = "0%";
  PartyCell_Width = "0%";
  ConsCell_Width = "0%";
  referred_Width = "0%";
  selectedRowIndex: any;
  RemarksCell_Width: string;
  VIPCell_Width: string;
  langservice: any;

  reportTitle: string="";
  imageConfigData: any;
  maxAgeColorCode:number;
  minAgeColorCode:number;
  docterEmr: docterEmrModel ={};
  constructor(private http: HttpClient, private authservice: AuthService,
    private datePipe: DatePipe,
    public snackBar: MatSnackBar,
    private dialog: MatDialog,
    //public opdvisitService: OpdVisitService
  ) {



    //this.baseUrl =this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;


    //  this.getproductionConfrigration()

  }


  getproductionConfrigration() {
    this.http.get<any>(this.newbaseUrl + "Common/GetProductType").subscribe(data => {
      // console.log('live config',data);
      // this.authservice.is_live = data;
    });


  }

  getdatabeforeScreen() {
    this.getopdvisit().
      subscribe((data: any) => {
        this.preloaddahsboard = data;
      }, err => {

      });
  }
  getsummary_url() {

    return this.http.get<any>(this.newbaseUrl + "Common/GetApplicationSetting/" + this.authservice.Loggeduser.branchid);
  }
  save_waiting_reason(visitid: number, reason: string) {
    return this.http.get(this.newbaseUrl + "VisitMaster/UpdateWaiting/" + visitid + "/" +
      this.authservice.Loggeduser.userid + "/" +
      this.authservice.Loggeduser.branchid + "/9/" + reason);
  }


  updateremark(visitid: number, remark: string) {
    return this.http.get(this.newbaseUrl + "VisitMaster/UpdateRemark/" + visitid + "/" + remark)
  }

  update_category(catid: number, visitid: number) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/UpdateCategory/" + visitid + "/" + catid);
  }


  add_dashboard_remark() {
    // this.addremark.remarks = this.addremark.remarks.substring(0,69);

    this.addremark.Remarks = this.addremark.Remarks.substring(0, 250);

    this.setdefault_remark_values();

    return this.http.post<any>(this.newbaseUrl + "VisitMaster/AddRemark", this.addremark);

  }

  getWhatsapp(modeldata: any) {
    return this.http.post<any>(this.newbaseUrl + "values/GetWhatsApp/", modeldata);
  }

  open_loader_Dialog(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      ////console.log('The dialog was closed');
      //pid = result;
    });
  }
  open_loader_Dialogtwo(): void {

    const loaderComp = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    loaderComp.afterClosed().subscribe(result => {
      ////console.log('The dialog was closed');
      //pid = result;
    });
  }

  setdefault_remark_values() {
    this.addremark.FkVisitId = this.visitid;
    this.addremark.FkRegId = this.pid;
    ////console.log ("fk_regid " + this.addremark.FkRegId);
    this.addremark.FromWhere = this.authservice.Loggeduser.userid;
    ////console.log ("FromWhere " +  this.addremark.FromWhere);
    this.addremark.Source = this.pid;
    ////console.log ("Source " + this.addremark.Source);
    let todaysdate = new Date();
    this.addremark.EnterTime = this.datePipe.transform(todaysdate, "hh:mm:ss a")
  }



  get_dashboard_remark() {
    // this.setdefault_remark_values();
    //console.log ("visit id "+ this.visitid);
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetRemarkList/" + this.visitid);

  }



  delete_dashboard_remark(remarkid: number) {
    //  this.setdefault_remark_values();
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/DeleteRemark/" + remarkid)
  }





  getopdvisit() {

    return this.http.get<any>(this.newbaseUrl + "VisitMaster/VisitList/"
      + this.selecteddate + "/" + "0/0/0/" +
      this.authservice.Loggeduser.branchid +'/'+this.authservice.Loggeduser.specialityId);
   
  }

  getlocations() {

    this.http.get<any>(this.newbaseUrl + "PatientLocation/GetLocationAll/"+ this.authservice.Loggeduser.specialityId).
      subscribe(data => this.successlocations(data), err => this.failedlocations(err));
  }
  getcategoryreturn(){
    return  this.http.get<any>(this.newbaseUrl + "BillingCategoryMaster/GetCategory/" + this.authservice.Loggeduser.specialityId)
  }
  getcategories() {
    this.http.get<any>(this.newbaseUrl + "BillingCategoryMaster/GetCategory/" + this.authservice.Loggeduser.specialityId).
      subscribe(data => this.successcategories(data), err => this.failedcategories(err));
  }
  // doctors 6
  getall_doctors() {

    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetList/6"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/6"+'/'+this.authservice.Loggeduser.specialityId);
  }

  getoldphoto(Patientid: any) {

    if (Patientid) {
     // return this.http.get<any>(this.newbaseUrl + "PatientRegistration/GetAllOldPhoto/" + Patientid);
     return this.http.get<any>(this.newbaseUrl + "DocumentUpload/GetPatientDocumentDetailByRegIdByBranchIdByDocumentType/"+Patientid+'/'+this.authservice.Loggeduser.branchid+'/'+'PATIENTPHOTO');
    }
    else {
      this.openSnackBar("Please Select Patient First", "OK");
    }
  }
  getall_physicians() {
    // GetPHYList/userTypeId/ branchId/visitDate/locationId

    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetPHYList/23"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/23"+'/'+this.authservice.Loggeduser.specialityId);
  }

  // GetPHYList/userTypeId/ branchId/visitDate/locationId

  // optitioner 5
  getall_ops() {
    ////console.log("date parameter :" + this.selecteddate);
    //2019-07-29
    // http://49.50.108.154:7575/api/VisitMaster/GetOPList/5/1/2019-03-27/0
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetOPList/5"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/5"+'/'+this.authservice.Loggeduser.specialityId);
  }
  // auto ref 4
  getall_ars() {
    // http://49.50.108.154:7575/api/VisitMaster/GetArList/4/1/2019-03-27/0
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetArList/4"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/4"+'/'+this.authservice.Loggeduser.specialityId);
  }
  // counslar 7
  getall_css() {
    // http://49.50.108.154:7575/api/VisitMaster/GetConsList/7/1/2019-03-27/0
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetConsList/7"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/7"+'/'+this.authservice.Loggeduser.specialityId);
  }
  //procedure 8
  getall_prs() {
    // http://49.50.108.154:7575/api/VisitMaster/GetProList/8/1/2019-03-27/0
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetProList/8"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/8"+'/'+this.authservice.Loggeduser.specialityId);
  }
  //clinical department 3
  getall_cds() {
    // http://49.50.108.154:7575/api/VisitMaster/GetCDList/3/ 1/2019-03-27/0
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetCDList/3"
      + "/" + this.authservice.Loggeduser.branchid + "/" + this.selecteddate + "/3"+'/'+this.authservice.Loggeduser.specialityId);
  }

  _gettime_slots() {
    // this.http.get<any>(this.baseUrl + "TotaltimeForPatient/GetTime").
    //   subscribe(data => this.success_timeslots(data),
    //     err => this.failed_timeslots(err));
    this.http.get<any>(this.newbaseUrl + "Common/GetOPDManagerDashboardTimeAndColorConfiguration").
      subscribe(data => this.success_timeslots(data),
        err => this.failed_timeslots(err));

  }

  _getname_pattern() {
    this.getdocument_url().subscribe(data => this.success_name_pattern(data), err => this.failed_name_pattern(err));

  }

  success_name_pattern(data) {
    let pdata = data.filter(item => item.propertyName == "PatientNamePattern");
    this.authservice.Loggeduser.patientname_formula_id = pdata[0]?.propertyValue;
   let imagedata = data.filter(item => item.propertyName == "UsePaitentPhoto");
    this.imageConfigData = imagedata[0]?.propertyValue.toUpperCase();
    let mindata = data.filter(item => item.propertyName == "MinAgeColorCode");
    this.minAgeColorCode = mindata[0]?.propertyValue.toUpperCase();
    let maxdata = data.filter(item => item.propertyName == "MaxAgeColorCode");
    this.maxAgeColorCode = maxdata[0]?.propertyValue.toUpperCase();
  }

  failed_name_pattern(err) {

  }

  deletedoc(patientfilename: string, patid: number) {

    //console.log("patid " + patid);
    return this.http.get<any>(this.newbaseUrl + "PatientRegistration/DeleteFile/" + patid + "/" + patientfilename);
  }

  success_timeslots(data) {
    // //console.log("Timeslots " + data);
    this.timeslots = data;
    // //console.log("Timeslots " + this.timeslots[0].time1);
  }
  failed_timeslots(err) {

  }
  gethospitalToalAppt(){
    return this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetAppAll/" + this.selecteddate + "/" +
    this.authservice.Loggeduser.branchid +'/'+ this.authservice.Loggeduser.specialityId);
  }
  _gethospital_total_appointments() {
    // http://49.50.108.154:7575/api/OpdAppointment/GetAppAll/2019-04.10/1

    ////console.log("date: " + this.selecteddate);
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetAppAll/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.branchid +'/'+ this.authservice.Loggeduser.specialityId).
      subscribe(data => this.success_hospital_total_appointments(data),
        err => this.failed_hospital_total_appointments(err));
  }
  _gethospital_pending_appointments() {
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetAppointmentPendingAll/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.branchid +'/'+this.authservice.Loggeduser.specialityId).
      subscribe(data => this.success_hospital_pending_appointments(data),
        err => this.failed_hospital_pending_appointments(err));
  }
  _gethospital_booked_appointments() {
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetBookedAppAll/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.branchid +'/'+this.authservice.Loggeduser.specialityId).
      subscribe(data => this.success_hospital_booked_appointments(data),
        err => this.failed_hospital_booked_appointments(err));
  }
  _gethospital_cancled_appointments() {
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetAppCancelledAll/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.branchid +'/'+this.authservice.Loggeduser.specialityId).
      subscribe(data => this.success_hospital_canceled_appointments(data),
        err => this.failed_hospital_canceled_appointments(err));
  }

  _getdoc_total_appointments() {
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetAppAllByDoctor/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.userid + "/" +
      this.authservice.Loggeduser.branchid).
      subscribe(data => this.success_doctor_total_appointments(data),
        err => this.failed_doctor_total_appointments(err));
  }
  _getdoc_pending_appointments() {
    //console.log("uid: " + this.authservice.Loggeduser.userid)
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetAppointmentPendingByDoctor/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.branchid + "/" +
      this.authservice.Loggeduser.userid).
      subscribe(data => this.success_doctor_pending_appointments(data),
        err => this.failed_doctor_pending_appointments(err));
  }
  _getdoc_booked_appointments() {
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetBookedAppForDoctor/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.userid + "/" +
      this.authservice.Loggeduser.branchid).
      subscribe(data => this.success_doctor_booked_appointments(data),
        err => this.failed_doctor_booked_appointments(err));
  }
  _getdoc_cancled_appointments() {
    this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetCancelledAppForDoctor/" + this.selecteddate + "/" +
      this.authservice.Loggeduser.userid + "/" +
      this.authservice.Loggeduser.branchid).
      subscribe(data => this.success_doctor_canceled_appointments(data),
        err => this.failed_doctor_canceled_appointments(err));
  }


  success_doctor_total_appointments(data) {
    //console.log("doctors total data called");
    this.total_appointment_count = data;
  }

  failed_doctor_total_appointments(err) {
    //console.log("doctors total data failed");
    this.total_appointment_count = 0;
  }

  success_doctor_pending_appointments(data) {
    //console.log("doctors pending data called");
    this.pending_appointment_count = data;

  }

  failed_doctor_pending_appointments(err) {
    //console.log("doctors pending data failed");
    this.pending_appointment_count = 0;
  }

  success_doctor_booked_appointments(data) {
    //console.log("doctors booked data called");
    this.booked_appointment_count = data;
    ////console.log ("BA_DOC " + this.booked_appointment_count);
  }

  failed_doctor_booked_appointments(err) {
    //console.log("doctors booked data failed");
    this.pending_appointment_count = 0;
  }
  success_doctor_canceled_appointments(data) {
    //console.log("doctors canceled data called");
    this.canceled_appointment_count = data;
  }

  failed_doctor_canceled_appointments(err) {
    //console.log("doctors canceled data failed");
    this.canceled_appointment_count = 0;
  }


  success_hospital_total_appointments(data) {
    //console.log("");
    this.total_appointment_count = data;


  }

  failed_hospital_total_appointments(err) {
    this.total_appointment_count = 0;
  }

  success_hospital_pending_appointments(data) {
    this.pending_appointment_count = data;
  }

  failed_hospital_pending_appointments(err) {
    this.pending_appointment_count = 0;
  }
  success_hospital_booked_appointments(data) {

    this.booked_appointment_count = data;
  }

  failed_hospital_booked_appointments(err) {
    this.booked_appointment_count = 0;
  }
  success_hospital_canceled_appointments(data) {
    this.canceled_appointment_count = data;
  }

  failed_hospital_canceled_appointments(err) {
    this.canceled_appointment_count = 0;
  }


  successcategories(data) {
    this.categories = data;
  }
  failedcategories(err) {

  }

  successlocations(data) {
    this.locations = data;
    ////console.log("locations list:" + this.locations);
  }
  failedlocations(err) {

  }

 
  setwidth(item: any) {
    // console.log('default widh',item);
    switch (item.fieldName) {
      case "sequence": {
        this.SequenceCell_Width = item.width + "%";
        break;

      }
      case "MoveTo": {
        this.MoveToCell_Width = item.width + "%";
        break;

      }
      case "FreshOrReview": {
        this.ReviewCell_Width = item.width + "%";
        break;

      }


      case "PatientName": {
        this.PatientNameCell_Width = item.width + "%";
        // //console.log(this.PatientNameCell_Width);
        break;
      }

      case "FK_RegID": {
        this.UHIDCell_Width = item.width + "%";
        break;
      }

      case "AgeSexDesc": {
        this.AgeSexCell_Width = item.width + "%";
        break;
      }
      case "OLDMRDNO":{
        this.oldmrno_Width = item.width + "%";
        break;
      }
      case "ApptTime": {
        // this.ApptTimeCell_Width = "3%";
        this.ApptTimeCell_Width = item.width + "%";

        break;

      }

      case "VisitTime": {
        this.RptTimeCell_Width = item.width + "%";

        break;

      }
      case "CategoryName": {
        //this.CategoryNameCell_Width = "%";
        this.CategoryNameCell_Width = item.width + "%";
        //  this.CategoryNameCell_Width = 11 + "%";
        break;

      }
      case "AR": {

        this.ARCell_Width = item.width + "%";
        break;

      }

      case "OptName": {
        //this.OPCell_Width = "3%";
        this.OPCell_Width = item.width + "%";
        break;

      }

      case "Doctor": {
        this.DRCell_Width = item.width + "%";
        break;

      }

      case "Physician": {
        this.PHYCell_Width = item.width + "%";
        break;

      }

      case "ProN": {
        this.PROCell_Width = item.width + "%";
        break;

      }
      case "ClinicalDept": {
        this.CDCell_Width = item.width + "%";
        break;

      }
      case "DilationTime": {
        this.DilationTimeCell_Width = item.width + "%";
        break;

      }

      case "ISPD": {
        this.DOCCell_Width = item.width + "%";
        break;

      }
      case "TotalTime": {
        this.TotalTimeCell_Width = item.width + "%";
        break;

      }
      case "Party": {
        this.PartyCell_Width = item.width + "%";
        break;

      }
      case "Remarks": {
        // this.RemarksCell_Width = "15%";
        this.RemarksCell_Width = item.width + "%";
        break;

      }
      case "CONS": {
        // this.RemarksCell_Width = "15%";
        this.ConsCell_Width = item.width + "%";
        break;

      }
      case "VIP": {
        this.VIPCell_Width = item.width + "%";
        break;

      }
      case "ReferredBy": {
        this.referred_Width = item.width + "%";
        break;

      }

      default: {
        // //console.log("Invalid choice");
        break;
      }
    }

  }

  getlocationTitle(locationid: number) {
    if (this.locations != undefined) {
      var loccolrow = this.locations.find(item => item.pkLocationId == locationid);
      return 'Patient is with ' + loccolrow?.locationName;
    }

  }
  getlocationcolor(locationid: number) {
    if (this.locations != undefined) {
      var loccolrow = this.locations.find(item => item.pkLocationId == locationid);
      return loccolrow?.webBackColor;
    }

  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })

  }

  openSnackBar_regform(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 9000,
    })

  }

  getnationality(flag: any){
    return  this.http.get<any>(this.newbaseUrl + "Common/GetPopUpHelp/" + flag);
  }
  get_otherinformation_tab_dd(flag: any) {

    this.http.get<any>(this.newbaseUrl + "Common/GetPopUpHelp/" + flag).
      subscribe(data => this.success_dd(data, flag), err => this.failed_dd(err));
  }

  success_dd(data, flag: any) {
    switch (flag) {
      case 'MARITALSTATUS': {
        this.MaritalStatus = data.filter(item=>item.isActive ==true);
        // console.log("MS " + this.MaritalStatus[0].popupDescription);
        break;
      }

      case 'VIPREF': {
        this.GetVIP = data.filter(item=>item.isActive ==true);
        break;
      }
      case 'NATIONALITY': {
        this.GetNationality = data.filter(item=>item.isActive ==true);
        break;
      }
    }

  }
  failed_dd(err) {
    this.dialog.closeAll();
  }

  getdocument_url() {

    return this.http.get<any>(this.newbaseUrl + "Common/GetApplicationSetting/" + this.authservice.Loggeduser.branchid);
  }
  GetArea() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetFloor");
  }
  GetClinicalDepartment() {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetOpdManagerLocationByBranchId/" + this.authservice.Loggeduser.branchid);
  }
  // GetUserSubSpecialityByUserId() {
  //   return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserSubSpecialityByUserId/" + 0);
  // }
  getCouncelorStatus(pid) {
    return this.http.get<any>(this.newbaseUrl + "Councelor/GetPatientLastConsStatus/" + pid);
  }
  // getUserloginPermission() {
  //   return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserScreenpermissionByUserId")
  // }

  getUsertypemenuPermission() {
    return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserAuthTypeMenuPermissionDetailByAuthTypeId/" + this.authservice.Loggeduser.usertypeid +"/"+this.authservice.pklanguageid);
  }
  getPateintDEtails(patientid) {
    return this.http.get<any>(this.newbaseUrl + "PatientRegistration/GetPatient/" + patientid);
  }

  getDailationDetail() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetPopUpHelpGeneral/DILATEDWITH");
  }

  getDailationstart(pid: any, userid: any, type) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/UpdateLocationDilation/" +
      pid + "/" + userid + "/" + 1 + '/' + type);
  }
  getdialationStart(pid: any, ctime: any, dtime: any, selectedeye: any, userid: any, type,ftime:any) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/UpdateDilation/" +
      pid + "/" + ctime + "/" + dtime + "[" + selectedeye + "]" + "/" + userid + "/" + type  + "/"+ftime);
  }

  getlocationType(visitid: any, userid: any, n1: any, branchid: any, prelocationid: any, n2, n3) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/UpdateLocation/" +
      visitid + "/" + userid + "/" + n1 + "/" + branchid + "/" + prelocationid + "/" + n2 + '/' + n3);
  }

  getMobilenUmber(mobileNo) {
    return this.http
      .get<any>(
        this.newbaseUrl +
        "Patientregistration/GetByMobileNo/" +
        mobileNo
      );
  }
  getVisitdata(patientid,visitid,DoctorIdEmr){
    return  this.http.get<any>(this.newbaseUrl + "VisitMaster/GetVisitTable/" + patientid +'/'+visitid+'/'+DoctorIdEmr +'/'+this.authservice.Loggeduser.specialityId)
  }
  getPatientracking(patientid,visitidate){
    return  this.http.get<any>(this.newbaseUrl + "VisitMaster/GetOpdTracking/" + patientid
    + "/" + visitidate +'/'+this.authservice.Loggeduser.specialityId);
  }
  get_opto_data(visitid) {
   
    return this.http.get(this.newbaseUrl + "OptoExamination/GetOptoByVisitId/" + visitid)
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour >= 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }
  GetPatientBySearchTypeByValueOrderBy(Searchtype,ValuePara,OrderBy){
    return this.http.get<any>(this.newbaseUrl + "Patientregistration/GetPatientBySearchTypeByValueOrderBy/" + Searchtype + "/" + ValuePara + "/" + OrderBy);
  }
  GetPatientBySearchAppointmentOrderBy(Searchtype,ValuePara,OrderBy){
    return this.http.get<any>(this.newbaseUrl + "OpdAppointment/GetPatientBySearchTypeByValueOrderBy/" + Searchtype + "/" + ValuePara + "/" + OrderBy);
  }
  GetBookingSurgerylistOrderByid(Searchtype,tdate){
    return this.http.get<any>(this.newbaseUrl + "Councelor/GetBookingSurgerylistByRegIdForCallCenter/" + Searchtype + "/" + tdate);
  }
  GetDoneSurgeryByRegId(regid){
    return this.http.get<any>(this.newbaseUrl + "IPD/GetDoneSurgeryByRegIdForCallCenter/" + regid );
  }
  GetProcedureRegisterByRegId(regid){
    return this.http.get<any>(this.newbaseUrl + "Procedure/GetProcedureRegisterByRegIdForCallCenter/" + regid );
  }
  AppointmentCol(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetWebConfigurationByHeadName/AppointmentCol");
  }
  get_allergies(pid:any) {
    return this.http.get<any>(this.newbaseUrl + "HistoryDrugAllergy/" +
    pid)
  }
  getlastvisittransfer(pid,visitid){
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetOPDVisitByRegIdByVisitId/" + pid + "/" + visitid)
    
  }
   finishdilation(visitid:any) {
      this.popup_cancel = false;
      this.getdilationstatus(visitid);
      this.getdilation(visitid);
    }
  
    getdilationstatus(visitid) {
      this.getdialationStart(visitid, this.currenttime, this.dilationwith, this.selectedeye, this.authservice.Loggeduser.userid, 'finish',this.finishtime)
      .subscribe(data => this.success_dilation_finish(data),
        err => this.failed_dilation(err));
    }
  
    success_dilation_finish(data) {
      console.log("Dilation Finished");
    }
    failed_dilation(err) {
      if(err.status==403){
        this.openSnackBar("You Don't have Permission", "OK");
      }else{
        this.openSnackBar("Dilation Finished Fail", "OK");
      }
    }
    getdilation(visitid) {
      this.getDailationstart(visitid, this.authservice.Loggeduser.userid, 'finish')
        .subscribe(data => this.success_dilation(data),
          err => this.failed_dilation_msg(err));
    }
    success_dilation(data) {
    }
    failed_dilation_msg(err) {  
      if(err.status==403){
        this.openSnackBar("You Don't have Permission", "OK");
      }else{
        this.openSnackBar("API Failed", "OK");
      }
    }
    
}
